import React from "react";

interface WordCarouselProps {
  words: string[];
  className?: string;
}

export const WordCarousel: React.FC<WordCarouselProps> = ({ words, className = "" }) => {
  const duplicated = [...words, ...words];

  return (
    <div className={`relative overflow-hidden h-[1.5em] ${className}`}>
      <div
        className="absolute inset-x-0 top-0 animate-word-slide will-change-transform"
        style={{ height: `${duplicated.length * 16.666}%` }}
      >
        {duplicated.map((word, i) => (
          <div
            key={`${word}-${i}`}
            className="h-[16.666%] flex items-center justify-start text-foreground font-medium tracking-tight"
          >
            {word}
          </div>
        ))}
      </div>
      {/* gradient masks */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[22%] bg-gradient-to-b from-background to-transparent z-10" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[22%] bg-gradient-to-t from-background to-transparent z-10" />
    </div>
  );
};
